import { render, staticRenderFns } from "./nshop-order-view-pins.vue?vue&type=template&id=3bff4988&scoped=true&"
import script from "./nshop-order-view-pins.vue?vue&type=script&lang=js&"
export * from "./nshop-order-view-pins.vue?vue&type=script&lang=js&"
import style0 from "./nshop-order-view-pins.vue?vue&type=style&index=0&id=3bff4988&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bff4988",
  null
  
)

export default component.exports